// Lightweight analytics helper for GTM dataLayer events
export type TrackEventPayload = Record<string, unknown>;

// Guard against recursion: GTM + Mixpanel can push back to dataLayer and re-trigger tags
const RECENT_EVENT_MS = 800;
const MAX_EVENTS_PER_WINDOW = 5;
let lastPushes: { key: string; at: number }[] = [];

function shouldSkipPush(eventName: string, data?: TrackEventPayload): boolean {
  const key = eventName + "|" + JSON.stringify(data ?? {});
  const now = Date.now();
  const recent = lastPushes.filter((p) => now - p.at < RECENT_EVENT_MS);
  if (recent.length >= MAX_EVENTS_PER_WINDOW) return true;
  if (recent.some((p) => p.key === key)) return true;
  lastPushes = [...recent, { key, at: now }].slice(-MAX_EVENTS_PER_WINDOW);
  return false;
}

export function trackEvent(eventName: string, data?: TrackEventPayload): void {
  if (typeof window === "undefined") return;
  if (shouldSkipPush(eventName, data)) return;

  try {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: eventName,
      ...data,
    });
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("[trackEvent] Failed to push event", eventName, error);
    }
  }
}

